module.exports = __webpack_public_path__ + "media/img/customer-66d461b9.jpg";